// extracted by mini-css-extract-plugin
module.exports = {"transactionDetails":"float-transaction-details_transactionDetails_2xj_d"};